export const routeUrl = {
  login: '/login',
  unAuth: '/unauth',
  dashboard: '/dashboard',
  assetUpload: '/asset/upload',
  apkUploadClient: '/apk/upload/client',
  apkUploadContents: '/apk/upload/contents',

  preSubscriptions: '/product/preSubscriptions',

  adminRoles: '/adm/roles',
  adminRoleEdit: '/adm/role/edit',
  adminRoleCreate: '/adm/role/edit',

  adminUsers: '/adm/users',
  adminUserEdit: '/adm/user/edit',

  adminRoleGroups: '/adm/role-groups',
  adminRoleGroupEdit: '/adm/role-group/edit',
  adminRoleGroupCreate: '/adm/role-group/create',

  releaseMgnt: '/adm/release-mgnt',
  releaseDetail: '/adm/release-detail',
  multilingualMgnt: '/adm/multilingual-mgnt',
  multilingualDetail: '/adm/multilingual-detail',
  rapaelHomeCpMapping: '/rapael-home/cp-mapping',
  rapaelHomePatientsList: '/rapael-home/patients',
  rapaelHomePatientsDetail: '/rapael-home/patients',
  rapaelHomeUserList: '/rapael-home/users',
  rapaelHomeCalculator: '/rapael-home/calculator',

  rapaelHomeSubscriptionStatus: '/rapael-home/subscriptionStatus',
  rapaelHomePayment: '/rapael-home/payment',
  rapaelHomePaymentList: '/rapael-home/payments',

};



// WEBPACK FOOTER //
// ./src/routes/routeUrl.js